import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { EMPTY, Observable, catchError } from "rxjs";
import { RetrieveTokenService } from './services/retrieve-token.service'
import { ErrorNotificationService } from './services/error-notification.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly requestTimeoutMs = 30000;
  private retrieveTokenService!: RetrieveTokenService;

  constructor (inj: Injector, private errorNotifications: ErrorNotificationService){
    setTimeout(() => {
    this.retrieveTokenService = inj.get(RetrieveTokenService);});
  }


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>  {
    let req = request.clone({
      headers: request.headers.set("Content-Type", "application/json")
    });

    const skipIntercept = req.headers.has('skip');
    if (skipIntercept) {
        const modreq = req.clone({
            headers: req.headers.delete('skip')
        });
        return next.handle(modreq).pipe(catchError((error: any) => this.handleError(error)));
    } else{
      let idToken = '';

      if(this.retrieveTokenService)
        idToken = this.retrieveTokenService.getTokenVal;
      //console.log(idToken)
      if (idToken != '' ) {
        const cloned = req.clone({
          headers: req.headers.set("Authorization", "Bearer " + idToken)
        });
        // console.log(cloned.headers)
        //console.log(cloned.body);
        return next.handle(cloned)
            .pipe(catchError((error: any) => this.handleError(error)))
      }
      return EMPTY;
    }
  }

  private handleError(error: any): Observable<never> {
    console.error('There was an error!', error);
    this.errorNotifications.show({
      message: error?.error?.message ?? error?.message ?? 'The request could not be completed. Please try again.',
      status: error?.status
    });
    return EMPTY;
  }
}


// To skip multiple url's:  https://stackoverflow.com/questions/55522320/angular-interceptor-exclude-specific-urls
// What I wound up doing is having an array of urls (in Regex Format) that I did not want to be used in the interceptor like so:

// import { Injectable } from '@angular/core';
// import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
// import { Observable } from 'rxjs';

// @Injectable()
// export class AddCustomHeadersInterceptor implements HttpInterceptor {
//   urlsToNotUse: Array<string>;

//   constructor(
//   ) {

//     this.urlsToNotUse= [
//       'myController1/myAction1/.+',
//       'myController1/myAction2/.+',
//       'myController1/myAction3'
//     ];
//   }

//   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     if (this.isValidRequestForInterceptor(request.url)) {
//       let modifiedRequest = request.clone({
//         setHeaders: {
//           //DO WORK HERE
//         }
//       });

//       return next.handle(modifiedRequest);
//     }
//     return next.handle(request);
//   }

//   private isValidRequestForInterceptor(requestUrl: string): boolean {
//     let positionIndicator: string = 'api/';
//     let position = requestUrl.indexOf(positionIndicator);
//     if (position > 0) {
//       let destination: string = requestUrl.substr(position + positionIndicator.length);
//       for (let address of this.urlsToNotUse) {
//         if (new RegExp(address).test(destination)) {
//           return false;
//         }
//       }
//     }
//     return true;
//   }
// }